import { Vaccination } from 'src/app/auth/_models/vaccination';
import { Pet } from 'src/app/auth/_models/pet';
import { Vaccine } from './../_models/vaccine';
import { Observable } from 'rxjs/Observable';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Injectable } from '@angular/core';

@Injectable()
export class VaccineService {

    private vaccineCollection: AngularFirestoreCollection<Vaccine>;
    private vaccinationCollection: AngularFirestoreCollection<Vaccination>;

    constructor(
        private _firestore: AngularFirestore
    ) { }

    newVaccination(pet: Pet, vaccination: any) {
        return this._firestore
            .collection('pets')
            .doc(pet.uuid)
            .collection('vaccinations')
            .add(vaccination);
    }

    getPetVaccination(petId: string) {
        this.vaccinationCollection = this._firestore.collection<Vaccination>('pets/' + petId + '/vaccinations', ref =>
            ref
                .orderBy('primary_shot_date', 'asc')
        );

        return this.vaccinationCollection.snapshotChanges().map(o => {
            return o.map(item => {
                const data = item.payload.doc.data();
                const id = item.payload.doc.id;

                return new Vaccination({ ...{ uuid: id }, ...data });
            });
        });
    }

    getVaccines(): Observable<Vaccine[]> {

        this.vaccineCollection = this._firestore.collection<Vaccine>('vaccines', ref =>
            ref
                .orderBy('name', 'asc')
        );

        return this.vaccineCollection.snapshotChanges().map(o => {
            return o.map(item => {
                const data = item.payload.doc.data();
                const uuid = item.payload.doc.id;

                return new Vaccine({ ...{ uuid: uuid }, ...data });
            });
        });

    }
}
